// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"02ef50c8","248":"64cb53d5","607":"5b91e5bd","787":"78ebabbd","944":"7be24404"}[chunkId] + ".chunk.js";
};